module.exports = require("./kok.d.ts");